import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'mint-ui/lib/style.css'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

// FastClick
// import FastClick from 'fastclick'
// FastClick.attach(document.body)

// Moment.js日期处理类库 (Moment.js 太大弃用)
// import moment from 'moment'
// Vue.prototype.$moment = moment

// JsBridge
import JsBridge from '@utils/JsBridge'
Vue.use(JsBridge)

// Vue-Socket.io
import VueSocketIO from 'vue-socket.io'
Vue.use(
  new VueSocketIO({
    debug: true,
    connection: 'http://47.99.35.92:3000'
    // connection: 'http://192.168.0.108:3000'
  })
)

// 公共过滤器
import * as filters from '@utils/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
if (process.env.NODE_ENV === 'production') {
  Vue.prototype.baseSiteUrl = 'https://bluetown-h5.era3.net'
} else if (process.env.NODE_ENV === 'development') {
  Vue.prototype.baseSiteUrl = 'http://192.168.0.108:8080/'
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js